export enum OwnerOptions {
	Stock = -1,
	System = -2
}